// © Microsoft Corporation. All rights reserved.
import { getQueryParameterByName } from "./Util";
import { canUseDOM } from "@msnews/isomorphic-util";
/**
 * Logger that simply logs to console with minimum dependencies.
 * Used for bootstrap/inline script where we don't need any logging nor its dependencies.
 */
export class LiteLogger {
    /**
     * The constructor
     */
    constructor() {
        if (canUseDOM()) {
            this.isDebugEnabled = ((getQueryParameterByName(window.location.href, "debug") || "").toLowerCase() in { 1: 1, true: 1 }) ||
                ((getQueryParameterByName(window.location.href, "reqsrc") || "").toLowerCase() === "vp");
            // On debug mode, make webpack_require available as global function
            // so any code in packages could be triggered from console. Handy for debugging.
            if (this.isDebugEnabled && !global["TEST_ENV"]) {
                window.webpackRequire = __webpack_require__;
            }
        }
        else {
            this.isDebugEnabled = false; // isDebugEnabled should be set explictly using the setDebug method
        }
    }
    /**
     * Returns the logging service
     * @returns {ILoggingService}
     */
    getLoggingService() {
        return null;
    }
    /**
     * Checks whether we're running in debug mode.
     * @returns True when either debug=1 or debug=true is present as a query param, otherwise false.
     */
    isDebug() {
        return this.isDebugEnabled;
    }
    /**
     * Override the isDebug setting. Useful when server side rendering.
     */
    setDebug(isDebug) {
        this.isDebugEnabled = isDebug;
    }
    /**
     * Set the tags to filter logs.
     * @param tags Tags to filter logs. If empty, do not filter.
     */
    setTags(tags) {
        // Not supported in console logger at the moment
    }
    /**
     * Log console message.
     * Note that these are not output to the console unless you're in debug mode.
     * @param message - Message to log.
     * @param tags - Optional tags for specifying log type for filtering logs.
     */
    log(message, tags) {
        if (this.isDebug()) {
            console.info(message);
        }
    }
    /**
     * Log error message.
     * @param message - Message to log
     */
    logError(message) {
        console.error(message);
    }
    /**
     * Lazy log console message. Use this when the message being constructed is complex or expensive so that it's only evaluated if needed.
     * Note that the callback is not invoked and the message is not output unless you're in debug mode.
     * @param getMessage - The function to call to get message to log
     */
    logCallback(getMessage) {
        if (this.isDebug()) {
            console.info(getMessage());
        }
    }
    /**
     * Log the objects to the console.
     * Note that these are not output to the console unless you're in debug mode.
     * @param message - Array of messages to log
     */
    logObjects(...message) {
        if (this.isDebug()) {
            console.log(...message);
        }
    }
    /**
     * Log the object to the console.
     * Note that these are not output to the console unless you're in debug mode.
     * @param message - Array of messages to log
     */
    logSingleObject(message, isMetrics) {
        if (this.isDebug()) {
            console.log(message);
        }
    }
}
//# sourceMappingURL=LiteLogger.js.map